import $ from 'jquery';

import Vars from './../../vars';

import YandexMap from './../../classes/YandexMap';
import Action from './../classes/Action';
import Validation from './../classes/Validation';

import DropzoneCompany from './../dropzone/company';

import Modal from './../../components/Modal';
import Request from './../../components/request';
import Utils from './../../components/utils';

class Company {
    constructor (args) {
        let self = this;

        self._setArgs(args);
        self._init();
    }

    _elems = {
        $content : $(),
        $create  : $(),
        $edit    : $(),
        $modal   : $(),
        $form    : $()
    };

    _state = {
        item        : {},
        items       : {},
        breadcrumbs : {},
        fields      : {},
        dropzone    : {},
        map         : {}
    };

    _const = {
        id       : 'id',
        entities : 'companies',
        entity   : 'company',
        title : {
            add  : 'Добавление новой компании',
            edit : 'Редактирование компании'
        },
        button : {
            add  : 'Добавить',
            edit : 'Сохранить'
        }
    };

    _args = {
        mode : '',
        done : function(){},
        id   : 0
    };

    _utils = {
        validation : {}
    };

    _actions = {
        remove : {
            title: 'Удаление компании',
            before : function(args){
                let done       = args.done;
                const entities = args.entities;
                const entity   = args.entity;
                const id       = args.id;

                Request.send({
                    path: '/api/' + entities + '/' + id,
                    data: {
                        info : 'for_remove'
                    },
                    done: function(response) {
                        loader.decrease();
                        Utils.scrollToTop();

                        let item = response[entity];

                        if (
                            (item.objects && Object.keys(item.objects).length > 0)
                            ||
                            (item.buildings && Object.keys(item.buildings).length > 0)
                            ||
                            (item.sites && Object.keys(item.sites).length > 0)
                            ||
                            (item.widgets && Object.keys(item.widgets).length > 0)
                            ||
                            (item.feeds && Object.keys(item.feeds).length > 0)
                        ) {
                            new Modal({
                                title: 		'Удаление компании',
                                content: 	Utils.renderProfileTemplate('company-deleting-has-attached-ones', {
                                    [entity] : item
                                })
                            });
                        }
                        else {
                            done();
                        }
                    }
                });
            }
        },
        confirmation : {
            title: 'эту компанию'
        }
    };

    _setArgs = (args) => {
        let self = this;

        self._args.mode   = args.mode;
        self._args.done   = args.done || self._args.done;
        self._args.id     = args.id || self._args.id;
        self._args.title  = args.title;

        self._state.items = args.items || self._state.items;
    };

    _setFields = () => {
        let self = this;

        self._state.fields = {
            organizational_form : {
                title      : 'Организационно-правовая форма',
                type       : 'select',
                required   : true,
                value      : Object.keys(self._state.item).length ? self._state.item.organizational_form : '',
                options    : ifacade.constants.companies.organizational_forms
            },
            name                : {
                title       : 'Название',
                type        : 'string',
                required    : true,
                placeholder : 'Укажите название',
                value       : Object.keys(self._state.item).length ? self._state.item.name : ''
            },
            preview             : {
                type       : 'preview'
            },
            address      : {
                title       : 'Адрес',
                type        : 'string',
                class       : 'is-address streets-only',
                required    : true,
                placeholder : 'Укажите адрес',
                item        : Object.keys(self._state.item).length ? self._state.item : null,
                value       : Object.keys(self._state.item).length ? self._state.item.address : ''
            },
            address_number      : {
                title       : 'Номер дома',
                type        : 'string',
                required    : true,
                placeholder : 'Укажите номер дома',
                value       : Object.keys(self._state.item).length ? self._state.item.address_number : ''
            },
            location                 : {
                title       : 'Место на карте',
                type        : 'map',
                error       : 'Извините, в данный момент яндекс-карта недоступна. Попробуйте обновить страницу',
                required    : true,
                value       : Object.keys(self._state.item).length ? self._state.item.location.join(',') : ''
            },
            manager      : {
                title       : 'Имя контактного лица компании',
                type        : 'string',
                required    : true,
                placeholder : 'Укажите контактное лицо',
                value       : Object.keys(self._state.item).length ? self._state.item.manager : ''
            },
            phone      : {
                title       : 'Телефон',
                type        : 'phone',
                required    : true,
                placeholder : 'Укажите телефон',
                value       : Object.keys(self._state.item).length ? self._state.item.phone : '',
                has    : {
                    fax : {
                        title : 'факс',
                        value : Object.keys(self._state.item).length ? self._state.item.has_fax : 0
                    },
                    telegram : {
                        title : 'telegram',
                        value : Object.keys(self._state.item).length ? self._state.item.has_telegram : 0
                    },
                    whatsapp : {
                        title : 'whatsapp',
                        value : Object.keys(self._state.item).length ? self._state.item.has_whatsapp : 0
                    },
                    viber : {
                        title : 'viber',
                        value : Object.keys(self._state.item).length ? self._state.item.has_viber : 0
                    }
                },
                extra : {
                    link   : 'добавить дополнительный телефон',
                    count  : 5,
                    fields : {
                        phone : {
                            type : 'phone',
                            placeholder : 'Укажите дополнительный телефон',
                            value       : Object.keys(self._state.item).length ? self._state.item.extra_phones.split(',') : null,
                            has    : {
                                fax : {
                                    title : 'факс',
                                    value : Object.keys(self._state.item).length ? self._state.item.has_faxes.split(',') : 0
                                },
                                telegram : {
                                    title : 'telegram',
                                    value : Object.keys(self._state.item).length ? self._state.item.has_telegrams.split(',') : 0
                                },
                                whatsapp : {
                                    title : 'whatsapp',
                                    value : Object.keys(self._state.item).length ? self._state.item.has_whatsapps.split(',') : 0
                                },
                                viber : {
                                    title : 'viber',
                                    value : Object.keys(self._state.item).length ? self._state.item.has_vibers.split(',') : 0
                                }
                            }
                        }
                    }
                }
            },
            email      : {
                title       : 'E-mail',
                type        : 'email',
                required    : true,
                validation  : 'email',
                placeholder : 'Укажите e-mail',
                value       : Object.keys(self._state.item).length ? self._state.item.email : '',
                extra : {
                    link : 'добавить дополнительный email',
                    count  : 15,
                    fields : {
                        email : {
                            type : 'email',
                            placeholder : 'Укажите дополнительный email',
                            value       : Object.keys(self._state.item).length ? self._state.item.extra_emails.split(',') : null
                        }
                    }
                }
            },
            url          : {
                title       : 'Официальный сайт',
                type        : 'string',
                placeholder : 'Укажите сайт',
                value       : Object.keys(self._state.item).length ? self._state.item.url.replace(/(^\w+:|^)\/\//, '') : null,
                protocols   : {
                    http  : Object.keys(self._state.item).length && self._state.item.url.indexOf('http://') !== -1 ? true : false,
                    https : !Object.keys(self._state.item).length || (Object.keys(self._state.item).length && self._state.item.url.indexOf('https://')) !== -1 ? true : false
                }
            },
            company_logo : {
                title : 'Логотип',
                type  : 'file',
                description : [
                    'Минимальный размер изображения: 80x80 пикселей',
                    'Максимальный вес изображения: 10 Мбайт'
                ]
            }
        };
    };

    _setValidation = () => {
        let self = this;

        if (!self._elems.$form.length) return;

        self._utils.validation = new Validation({
            form : self._elems.$form
        });
    };

    _setDropzone = () => {
        let self = this;

        self._state.dropzone.items = DropzoneCompany.get({
            item     : self._state.item,
            entities : self._const.entities
        });
        self._state.dropzone.entity = self._state.item;
    };

    _initMap = () => {
        let self = this;

        let $mapBlock = self._elems.$modal.find('.js-map');
        if (!$mapBlock.length) return;
        if(typeof ymaps === undefined || typeof ymaps === "undefined"){
            $mapBlock.prev('.form__field__error').show();
            $mapBlock.hide();
        }
        else {
            ymaps.ready(function () {
                if (Object.keys(self._state.item).length && self._state.item.location.length > 0) {
                    $mapBlock
                        .data('location', self._state.item.location.join(','))
                        .data('zoom', 16);

                    self._state.map = new YandexMap({
                        root    : $mapBlock,
                        options : {
                            afterRender : function(args) {
                                if (!args.map) return;
                            }
                        }
                    });
                }
                else {
                    ymaps.geocode((self._state.item ? self._state.item.address : '') || 'Москва', {
                        results: 1
                    }).then(function (response) {
                        const firstGeoObject = response.geoObjects.get(0);

                        if (firstGeoObject) {
                            const coordinates = firstGeoObject.geometry.getCoordinates();
                            $mapBlock
                                .data('location', coordinates.join(','))
                                .data('zoom', 9);
                        }
                        else {
                            $mapBlock
                                .data('location', '55.751574,37.573856')
                                .data('zoom', 9);
                        }

                        self._state.map = new YandexMap({
                            root    : $mapBlock,
                            options : {
                                afterRender : function(args) {
                                    if (!args.map) return;
                                }
                            }
                        });
                    });
                }
            });
        }
    };

    _initModal = () => {
        let self = this;

        self._setFields();
        self._setDropzone();

        self._elems.$modal = new Modal({
            title : Object.keys(self._state.item).length ? self._const.title.edit : self._const.title.add,
            closingConfirmation : true,
            confirm : function(args){
                self._bindSubmit(args);
            },
            content: Utils.renderProfileTemplate('form', {
                item     : self._state.item,
                entity   : self._const.entity,
                fields   : self._state.fields,
                buttons  : {
                    one : {
                        class : 'confirm button--edit',
                        title : Object.keys(self._state.item).length ? self._const.button.edit : self._const.button.add,
                        type  : 'submit'
                    },
                    two : {
                        class : 'button--cancel',
                        title : 'Отмена'
                    }
                }
            }),
            dropzone : self._state.dropzone
        });

        self._elems.$form = self._elems.$modal.find('form');

        self._setValidation();
        self._bindForm();
    };

    _bindForm = () => {
        let self = this;

        if (!self._elems.$form.length) return;

        self._elems.$form.find('select[name="company[organizational_form]"]').change(function() {
            self._updatePreview();
        });

        self._elems.$form.find('input[name="company[name]"]').keyup(function() {
            self._updatePreview();
        });

        self._elems.$form.find('input[name="company[url]"]').change(function() {
            const val = $(this).val().replace(/\s/g, '');
            if (val.indexOf('https://') != -1) {
                self._elems.$form.find('select[name="company[protocol]"]').val('https');
                $(this).val(val.substring('https://'.length));
            } else if (val.indexOf('http://') != -1) {
                self._elems.$form.find('select[name="company[protocol]"]').val('http');
                $(this).val(val.substring('http://'.length));
            }
        });

        self._initMap();
        self._bindAddress();
        self._updatePreview();
    };

    _bindActions = () => {
        let self = this;

        if (self._args.mode === Vars.view.index) return;
        if (self._args.mode === Vars.view.list) return;

        new Action({
            id       : self._state.item.id,
            actions  : self._actions,
            entities : self._const.entities,
            entity   : self._const.entity,
            self     : self
        });
    };

    _updatePreview = () => {
        let self = this;

        if (!self._elems.$form.length) return;

        const organizationalForm = self._elems.$form.find('select[name="company[organizational_form]"]').val();
        const name = self._elems.$form.find('input[name="company[name]"]').val();

        if (organizationalForm && name) {
            self._elems.$form.find('#company-form-preview').text(ifacade.constants.companies.organizational_forms[organizationalForm].short_name + ' "' + name + '"').slideDown();
        }
        else {
            self._elems.$form.find('#company-form-preview').text('---').slideUp();
        }
    };

    _index = () => {
        let self = this;
        self._bindUI();
    };

    _list = () => {
        let self = this;

        Request.send({
            path: '/api/' + self._const.entities,
            done: function(response) {
                loader.decrease();
                Utils.scrollToTop();

                self._state.items = response[self._const.entities];
                self._state.item  = {};

                self._state.breadcrumbs = Utils.renderProfileTemplate('breadcrumbs', {
                    crumbs : [
                        {
                            title : 'Главная',
                            href  : '#'
                        },
                        {
                            title : self._args.title
                        }
                    ],
                    title    : self._args.title,
                    dropdown : null,
                    activate : null
                });

                self._elems.$content.html(Utils.renderProfileTemplate(self._const.entities, {
                    breadcrumbs            : self._state.breadcrumbs,
                    [self._const.entities] : self._state.items
                }));

                self._bindElements();
                self._bindUI();
            }
        });
    };

    _object = () => {
        let self = this;

        self._initModal();
    };

    _item = () => {
        let self = this;

        Request.send({
            path: '/api/' + self._const.entities + '/' + self._args.id,
            done: function(response) {
                loader.decrease();
                Utils.scrollToTop();

                self._state.item  = response[self._const.entity];
                self._state.items = {};

                self._state.breadcrumbs = Utils.renderProfileTemplate('breadcrumbs', {
                    crumbs : [
                        {
                            title : 'Главная',
                            href  : '#'
                        },
                        {
                            title : 'Компании',
                            href  : '#' + self._const.entities
                        },
                        {
                            title : self._state.item.name
                        }
                    ],
                    dropdown : null,
                    activate : null
                });

                self._elems.$content.html(Utils.renderProfileTemplate(self._const.entity, {
                    breadcrumbs : self._state.breadcrumbs,
                    company     : self._state.item
                }));

                self._bindElements();
                self._bindUI();
            }
        });
    };

    _bindElements = () => {
        let self = this;
        self._elems.$content = !self._elems.$content.length ? $('.content') : self._elems.$content;
        if(!self._elems.$content.length) return;

        self._elems.$create = self._elems.$content.find('.js-profile-company-create');
        self._elems.$edit   = self._elems.$content.find('.js-profile-company-edit');
    };

    _bindAddress = () => {
        let self = this;

        self._elems.$form.find('input[name="company[address_number]"]').on('keyup', function(e) {
            const addressNumber = $(this).val();
            const addressElementId = self._elems.$form.find('input[name="company[address_element_id]"]').val();
            if (!addressElementId) return;

            const address = self._elems.$form.find('.form-field[data-name="address"] .input input[type="text"]').val();
            if (!address) return;

            ymaps.ready(function() {
                ymaps.geocode(address + (addressNumber ? ' ' + addressNumber : ''), {
                    results: 1,
                }).then(function(response) {
                    const firstGeoObject = response.geoObjects.get(0);
                    if(!firstGeoObject) return;

                    const coordinates = firstGeoObject.geometry.getCoordinates();
                    self._state.map.setCenter(coordinates, 16);
                    self._elems.$form.find('input[name="company[location]"]').val(coordinates.join(','));
                });
            });

            let $location = self._elems.$form.find('.form-field[data-name="location"]');
            if (!$location.length) return;
            $location.removeClass('error');
        });

        self._elems.$form.find('.form-field[data-name="address"] .input').unbind('change').on('change', function() {
            const addressNumber = self._elems.$form.find('input[name="company[address_number]"]').val();
            const address = $(this).find('input[type="text"]').val();

            if (!address) return;

            ymaps.ready(function() {
                ymaps.geocode(address + (addressNumber ? ' ' + addressNumber : ''), {
                    results: 1,
                }).then(function(response) {
                    const firstGeoObject = response.geoObjects.get(0);
                    if(!firstGeoObject) return;

                    const coordinates = firstGeoObject.geometry.getCoordinates();
                    self._elems.$form.find('input[name="company[location]"]').val(coordinates.join(','));
                    self._state.map.setCenter(coordinates, 16);
                });
            });

            let $location = self._elems.$form.find('.form-field[data-name="location"]');
            if (!$location.length) return;
            $location.removeClass('error');
        });
    };

    _bindSubmit = (args) => {
        let self = this;

        let $modal = args.modal;
        if (!$modal.length) return;
        let $form = $modal.find('form');
        if (!$form.length) return;

        loader.increase();

        Request.send({
            path: 		'/api/' + self._const.entities + '/' + (Object.keys(self._state.item).length ? self._state.item.id + '/edit' : 'create'),
            method: 	'POST',
            data: 		$form.serialize(),

            done: function(response) {
                loader.decrease();

                if (response.error) {
                    self._utils.validation.showErrors(response.error);
                    return
                }

                self._state.item  = response[self._const.entity];

                if(self._args.mode == Vars.view.object) {
                    self._args.done(self._state.item);
                    $modal.trigger('close');
                } else if(Object.keys(self._state.items).length || self._args.mode == Vars.view.index) {
                    window.location.href = '#' + self._const.entities + '/' + self._state.item.id;
                    $modal.trigger('close');
                }
                else {
                    $modal.trigger('close');

                    self._state.breadcrumbs = Utils.renderProfileTemplate('breadcrumbs', {
                        crumbs : [
                            {
                                title : 'Главная',
                                href  : '#'
                            },
                            {
                                title : 'Компании',
                                href  : '#' + self._const.entities
                            },
                            {
                                title : self._state.item.name
                            }
                        ],
                        title    : self._args.title,
                        dropdown : null,
                        activate : null
                    });

                    self._elems.$content.html(Utils.renderProfileTemplate(self._const.entity, {
                        breadcrumbs          : self._state.breadcrumbs,
                        [self._const.entity] : self._state.item
                    }));
                    self._bindElements();
                    self._bindUI();
                }
            }
        });
    };

    _bindUI = () => {
        let self = this;

        self._elems.$create.length && self._elems.$create.unbind('click').on('click', function(e) {
            e.preventDefault();
            self._initModal();
        });

        self._elems.$edit.length && self._elems.$edit.unbind('click').on('click', function(e) {
            e.preventDefault();
            loader.increase();

            Request.send({
                path: '/api/' + self._const.entities + '/' + self._state.item.id,
                done: function (response) {
                    loader.decrease();
                    Utils.scrollToTop();

                    self._state.item = response[self._const.entity];
                    self._initModal();
                }
            });
        });

        self._bindActions();
    };

    _clear = () => {
        let self = this;


    };

    _init = () => {
        let self = this;

        self._bindElements();

        if (self._args.mode === Vars.view.index) {
            self._index();
        } else if (self._args.mode === Vars.view.object) {
            self._object();
        } else if (self._args.mode === Vars.view.list) {
            self._list();
        } else if (self._args.mode === Vars.view.item) {
            self._item();
        }
    };
}

export default Company;